import { Alert } from '@vtex/shoreline'

import Form from '~/components/unform/Form'
import { useCampaignForm } from '~/modules/retailMedia/components/CampaignForm/hooks/useCampaignForm'
import { useIsManagedByVtex } from '~/modules/retailMedia/hooks/useIsManagedByVtex'

import CampaignType from '../../elements/CampaignType'
import { LinkInsertionOrderBlock } from '../../elements/LinkInsertionOrderBlock'
import * as instoreComponents from './Instore'
import * as offsiteComponents from './Offsite'
import * as onsiteComponents from './Onsite'

const FallbackComponent = () => (
  <Alert variant="warning">Invalid campaign type.</Alert>
)

const CreateStandardCampaign: React.FC = () => {
  const { selectedType, adTypeIsValid } = useCampaignForm()
  const { isManagedByVtex } = useIsManagedByVtex()

  const Component =
    {
      ...instoreComponents,
      ...onsiteComponents,
      ...offsiteComponents
    }[selectedType] || FallbackComponent

  if (selectedType && !adTypeIsValid) {
    return <FallbackComponent />
  }

  return (
    <>
      {!!isManagedByVtex && <LinkInsertionOrderBlock />}

      {selectedType ? (
        <Component />
      ) : (
        <Form initialData={{ type: selectedType }}>
          <CampaignType />
        </Form>
      )}
    </>
  )
}

export default CreateStandardCampaign
